// Privana-authored presentation only; tenant content and evidence remain verbatim.
export default {
  "copy": {
    "selectAnActiveFrameworkVersion": "Seleccione una versión activa del marco.",
    "thisFrameworkIsNotApplicableToThisClub": "Este marco no es aplicable a este club.",
    "selectACompletedAssessmentFromTheSameFramework": "Seleccione una evaluación completada del mismo marco.",
    "aCompletedPriorAssessmentIsRequired": "Se requiere una evaluación previa completada.",
    "selectAnActiveMemberOfThisClubSStaff": "Seleccione un miembro activo del personal de este club.",
    "startTheAssessmentBeforeEvaluatingControls": "Inicie la evaluación antes de evaluar los controles.",
    "completedAndCancelledAssessmentsAreImmutable": "Las evaluaciones completadas y canceladas no se pueden modificar.",
    "selectAValidAssessmentResult": "Seleccione un resultado de evaluación válido.",
    "addAMeaningfulNarrativeForThisResult": "Añada una explicación suficiente para este resultado.",
    "evaluateEveryControlBeforeCompletingTheAssessment": "Evalúe todos los controles antes de completar la evaluación.",
    "youDoNotHavePermissionToPerformThisOperation": "No tiene permiso para realizar esta operación.",
    "theAssessmentWasNotFoundForThisClub": "No se ha encontrado la evaluación para este club.",
    "anActiveFindingAlreadyExistsForThisAssessmentResult": "Ya existe un hallazgo activo para este resultado de evaluación.",
    "onlyPartiallyCompliantOrNonCompliantResultsCanBecomeFindings": "Solo los resultados de cumplimiento parcial o de incumplimiento pueden generar hallazgos.",
    "selectLowMediumHighOrCritical": "Seleccione Bajo, Medio, Alto o Crítico.",
    "enterAFindingTitle": "Introduzca un título para el hallazgo.",
    "describeTheComplianceDeficiency": "Describa la deficiencia de cumplimiento.",
    "theAssessmentOperationCouldNotBeCompleted": "No se ha podido completar la operación de evaluación.",
    "assessments": "Evaluaciones",
    "evaluateEveryCanonicalControlInAnActiveFrameworkVersion": "Evalúe cada control canónico de una versión activa del marco.",
    "newAssessment": "Nueva evaluación",
    "searchAssessments": "Buscar evaluaciones",
    "searchAssessments2": "Buscar evaluaciones…",
    "status": "Estado",
    "framework": "Marco",
    "assessmentType": "Tipo de evaluación",
    "all": "Todos",
    "loadingAssessments": "Cargando evaluaciones…",
    "noAssessmentsYet": "Aún no hay evaluaciones",
    "assessmentsEvaluateYourClubAgainstTheControlsInAnActiveComplianceFramework": "Las evaluaciones permiten evaluar su club con respecto a los controles de un marco de cumplimiento activo.",
    "createAssessment": "Crear evaluación",
    "assessment": "Evaluación",
    "version": "Versión",
    "type": "Tipo",
    "owner": "Responsable",
    "progress": "Progreso",
    "started": "Iniciada",
    "completed": "Completada",
    "updated": "Actualizado",
    "evaluated": " evaluados",
    "selectActiveFrameworkVersion": "Seleccione una versión activa del marco",
    "controls": "controles",
    "assessmentTitle": "Título de la evaluación",
    "defaultToMe": "Asignarme por defecto",
    "loadingCompletedAssessments": "Cargando evaluaciones completadas…",
    "selectCompletedPriorAssessment": "Seleccione una evaluación previa completada",
    "completed2": "· Completada",
    "noCompletedAssessmentsAreAvailableForReassessmentAgainstThisFramework": "No hay evaluaciones completadas disponibles para una reevaluación de este marco.",
    "createDraftAssessment": "Crear borrador de evaluación",
    "unassigned": "Sin asignar",
    "created": "Creado",
    "complete": "% completado",
    "startAssessment": "Iniciar evaluación",
    "completeAssessment": "Completar evaluación",
    "cancel": "Cancelar",
    "searchControls": "Buscar controles…",
    "category": "Categoría",
    "result": "Resultado",
    "importance": "Importancia",
    "controlVersion": "· Versión del control {version}",
    "requirement": "Requisito",
    "guidance": "Orientaciones",
    "applicabilityGuidance": "Orientaciones de aplicabilidad",
    "evaluationMethod": "Método de evaluación",
    "evidenceMethod": "Método de evidencia",
    "reviewFrequency": "Frecuencia de revisión",
    "currentAssessmentResult": "Resultado actual de la evaluación",
    "assessmentNarrative": "Explicación de la evaluación",
    "saveEvaluation": "Guardar evaluación",
    "finding": "Hallazgo",
    "raiseFinding": "Registrar hallazgo",
    "title": "Título",
    "description": "Descripción",
    "severity": "Gravedad",
    "onlyCompletedAssessmentsCanBeUsedForAnAuditPack": "Solo se pueden usar evaluaciones completadas en un paquete de auditoría.",
    "thisAuditPackCouldNotBeFound": "No se ha encontrado este paquete de auditoría.",
    "thisAuditPackCanNoLongerBeChanged": "Este paquete de auditoría ya no se puede modificar.",
    "thisAuditPackIsAlreadyBeingGenerated": "Este paquete de auditoría ya se está generando.",
    "generationOwnershipChangedRefreshAndTryAgain": "Ha cambiado la titularidad del proceso de generación. Actualice la página e inténtelo de nuevo.",
    "tooManyCurrentEvidenceDocumentsAreInScope": "El alcance incluye demasiados documentos de evidencia vigentes.",
    "theEvidencePackageIsTooLargeToGenerateSafely": "El paquete de evidencias es demasiado grande para generarlo de forma segura.",
    "aCurrentEvidenceDocumentCouldNotBeRetrievedNoIncompletePackageWasGenerated": "No se ha podido recuperar un documento de evidencia vigente. No se ha generado ningún paquete incompleto.",
    "enterARationaleBeforeVoidingThisAuditPack": "Introduzca una justificación antes de anular este paquete de auditoría.",
    "unableToCompleteTheAuditPackOperation": "No se ha podido completar la operación del paquete de auditoría.",
    "loadingAssuranceOverview": "Cargando el resumen de aseguramiento…",
    "setUpYourComplianceProgramme": "Configure su programa de cumplimiento",
    "privanaCanHelpYouBuildAStructuredAssuranceProgrammeForYourClub": "Privana puede ayudarle a crear un programa de aseguramiento estructurado para su club.",
    "chooseAFramework": "Elija un marco",
    "startWithAPrivanaTemplateOrCreateYourOwn": "Empiece con una plantilla de Privana o cree la suya.",
    "reviewYourControls": "Revise sus controles",
    "tailorTheSuggestedRequirementsToYourClub": "Adapte los requisitos sugeridos a su club.",
    "runYourFirstAssessment": "Realice su primera evaluación",
    "establishYourCurrentCompliancePosition": "Determine su situación actual de cumplimiento.",
    "step": "Paso",
    "setUpCompliance": "Configurar cumplimiento",
    "overallCompliance": "Cumplimiento general",
    "notAssessed": "Sin evaluar",
    "openFindings": "Hallazgos abiertos",
    "actionsDue": "Acciones pendientes de vencimiento",
    "auditReadiness": "Preparación para auditoría",
    "notEnoughData": "Datos insuficientes",
    "assuranceReadinessIndicatorNotCertification": "Indicador de preparación para el aseguramiento, no una certificación",
    "executiveAssurance": "Aseguramiento para la dirección",
    "currentAssurancePostureFromCanonicalComplianceRecords": "Situación actual de aseguramiento basada en los registros canónicos de cumplimiento.",
    "readinessDimensions": "Dimensiones de preparación",
    "notMeasurable": "No medible",
    "recentComplianceActivity": "Actividad reciente de cumplimiento",
    "timesShownIn": "Horas mostradas en",
    "auditPacks": "Paquetes de auditoría",
    "immutableVersionedAssuranceSnapshotsForFormalReview": "Instantáneas de aseguramiento inmutables y versionadas para su revisión formal.",
    "newAuditPack": "Nuevo paquete de auditoría",
    "searchAuditPacks": "Buscar paquetes de auditoría",
    "searchPacks": "Buscar paquetes…",
    "statusFilter": "Filtro de estado",
    "allStatuses": "Todos los estados",
    "draft": "Borrador",
    "generating": "Generando",
    "generated": "Generado",
    "void": "Anulado",
    "noAuditPacks": "No hay paquetes de auditoría",
    "createAPackFromACompletedAssessment": "Cree un paquete a partir de una evaluación completada.",
    "pack": "Paquete",
    "generatedBy": "Generado por",
    "documents": "Documentos",
    "selectCompletedAssessment": "Seleccione una evaluación completada…",
    "includeEvidenceDocuments": "Incluir documentos de evidencia",
    "createDraft": "Crear borrador",
    "noDescriptionProvided": "No se ha proporcionado ninguna descripción.",
    "generateAuditPack": "Generar paquete de auditoría",
    "generatingAuditPack": "Generando paquete de auditoría…",
    "theImmutableReportAndAuthorisedEvidencePackageAreBeingPreparedRefreshToCheckItsStatus": "Se están preparando el informe inmutable y el paquete de evidencias autorizado. Actualice la página para consultar el estado.",
    "manifestV": "Manifiesto v",
    "downloadPDF": "Descargar PDF",
    "downloadEvidencePackage": "Descargar paquete de evidencias",
    "voidAuditPack": "Anular paquete de auditoría",
    "voidingIsTerminalExplainWhyThisDraftMustNotBeGenerated": "La anulación es definitiva. Explique por qué no debe generarse este borrador.",
    "voidRationale": "Justificación de anulación",
    "voidRationale2": "Justificación de anulación…",
    "actionDue": "Vencimiento de acción",
    "safetyReview": "Revisión de seguridad operativa",
    "complianceDate": "Fecha de cumplimiento",
    "owner2": "Responsable:",
    "priority": "prioridad",
    "overdue": "Vencido",
    "open": "Abrir",
    "youDoNotHaveAccessToTheComplianceCalendar": "No tiene acceso al calendario de cumplimiento.",
    "theComplianceCalendarCouldNotBeLoaded": "No se ha podido cargar el calendario de cumplimiento.",
    "complianceCalendar": "Calendario de cumplimiento",
    "dueThisWeek": "Vencen esta semana",
    "next30Days": "Próximos 30 días",
    "safetyReviewsDue": "Revisiones de seguridad operativa pendientes",
    "previousMonth": "Mes anterior",
    "today": "Hoy",
    "nextMonth": "Mes siguiente",
    "calendarView": "Vista del calendario",
    "calendar": "Calendario",
    "agenda": "Agenda",
    "filters": "Filtros",
    "eventCategory": "Categoría del evento",
    "allEvents": "Todos los eventos",
    "actions": "Acciones",
    "frameworks": "Marcos",
    "safetyReviews": "Revisiones de seguridad operativa",
    "timing": "Plazo",
    "allDates": "Todas las fechas",
    "upcoming": "Próximos",
    "loadingComplianceDates": "Cargando fechas de cumplimiento",
    "loadingComplianceDates2": "Cargando fechas de cumplimiento…",
    "sun": "dom",
    "mon": "lun",
    "tue": "mar",
    "wed": "mié",
    "thu": "jue",
    "fri": "vie",
    "sat": "sáb",
    "more": "más",
    "selectedDayAgenda": "Agenda del día seleccionado",
    "noComplianceItemsForThisDay": "No hay elementos de cumplimiento para este día.",
    "noComplianceDatesInThisPeriod": "No hay fechas de cumplimiento en este período",
    "today2": " · Hoy",
    "date": "Fecha",
    "andTime": " y hora",
    "sourceReference": "Referencia de origen",
    "context": "Contexto",
    "priority2": "Prioridad",
    "close": "Cerrar",
    "thatKeyAndVersionAlreadyExists": "Esa clave y versión ya existen.",
    "activeAndRetiredControlsCannotBeEditedCreateANewVersionInstead": "Los controles activos y retirados no se pueden editar. Cree una nueva versión.",
    "onlyDraftFrameworkVersionsCanHaveTheirControlsChanged": "Solo se pueden cambiar los controles de las versiones de marco en borrador.",
    "activateEveryAttachedControlBeforeActivatingThisVersion": "Active todos los controles asociados antes de activar esta versión.",
    "onlyActiveControlsCanBeAssignedToAFrameworkVersion": "Solo se pueden asignar controles activos a una versión del marco.",
    "controlOrderingMustUseNonNegativeWholeNumbers": "El orden de los controles debe usar números enteros no negativos.",
    "eachAssignedControlMustHaveAUniqueOrder": "Cada control asignado debe ocupar una posición única.",
    "thisFrameworkAlreadyHasAnActiveVersionSupersedeOrRetireItExplicitlyFirst": "Este marco ya tiene una versión activa. Primero sustitúyala o retírela explícitamente.",
    "aRationaleIsRequiredWhenAFrameworkIsNotApplicable": "Se requiere una justificación cuando un marco no es aplicable.",
    "theEffectiveToDateMustBeOnOrAfterEffectiveFrom": "La fecha de fin de vigencia debe ser igual o posterior a la fecha de inicio.",
    "youDoNotHaveComplianceEditPermission": "No tiene permiso de edición de cumplimiento.",
    "attachAtLeastOneActiveControlBeforeActivation": "Asocie al menos un control activo antes de la activación.",
    "createAFrameworkVersionBeforeActivatingThisFramework": "Cree una versión del marco antes de activar este marco.",
    "thisLifecycleActionIsNotValidForTheCurrentStatus": "Esta acción del ciclo de vida no es válida para el estado actual.",
    "theComplianceOperationCouldNotBeCompleted": "No se ha podido completar la operación de cumplimiento.",
    "no": "No hay",
    "yet": " todavía",
    "controlsDefineTheRequirementsUsedByComplianceFrameworksAndAssessments": "Los controles definen los requisitos utilizados por los marcos y las evaluaciones de cumplimiento.",
    "frameworksOrganiseReusableControlsIntoADefinedComplianceProgramme": "Los marcos organizan controles reutilizables en un programa de cumplimiento definido.",
    "create": "Crear",
    "control": "Control",
    "privanaWillGenerateTheControlReferenceAutomatically": "Privana generará automáticamente la referencia del control.",
    "controlDefinition": "Definición del control",
    "assuranceSettings": "Configuración de aseguramiento",
    "controlLibrary": "Biblioteca de controles",
    "reusableVersionedRequirementsForYourComplianceProgrammes": "Requisitos reutilizables y versionados para sus programas de cumplimiento.",
    "browsePrivanaLibrary": "Explorar la biblioteca de Privana",
    "newControl": "Nuevo control",
    "searchControls2": "Buscar controles",
    "allCategories": "Todas las categorías",
    "allImportance": "Todos los niveles de importancia",
    "loadingControls": "Cargando controles…",
    "evaluation": "Evaluación",
    "evidence": "Evidencias",
    "createControl": "Crear control",
    "frameworkReferences": "Referencias del marco",
    "edit": "Editar",
    "activate": "Activar",
    "createNewVersion": "Crear nueva versión",
    "retire": "Retirar",
    "editDraftControl": "Editar borrador de control",
    "saveChanges": "Guardar cambios",
    "createNewControlVersion": "Crear nueva versión del control",
    "createDraftVersion": "Crear versión en borrador",
    "availableControls": "Controles disponibles",
    "available": "disponibles",
    "searchAvailableControls": "Buscar controles disponibles",
    "searchActiveControls": "Buscar controles activos…",
    "availableControlCategory": "Categoría del control disponible",
    "availableControlImportance": "Importancia del control disponible",
    "version2": "· Versión",
    "add": "Añadir",
    "allMatchingControlsAreAlreadyAssigned": "Todos los controles coincidentes ya están asignados.",
    "assignedControls": "Controles asignados",
    "assigned": "asignados",
    "searchAssignedControls": "Buscar controles asignados",
    "searchAssignedControls2": "Buscar controles asignados…",
    "frameworkReferenceFor": "Referencia del marco para",
    "frameworkReferenceOptional": "Referencia del marco (opcional)",
    "moveUp": "Subir",
    "moveDown": "Bajar",
    "removeControl": "Quitar control",
    "noAssignedControlsMatchThisSearch": "Ningún control asignado coincide con esta búsqueda.",
    "controlsAssigned": "Controles asignados",
    "privanaComplianceLibrary": "Biblioteca de cumplimiento de Privana",
    "loadingPrivanaTemplates": "Cargando plantillas de Privana…",
    "privanaLibraryIsTemporarilyUnavailableYouCanStillBuildACustomFramework": "La biblioteca de Privana no está disponible temporalmente. Puede seguir creando un marco personalizado.",
    "privanaTemplatesAreGuidanceAndShouldBeTailoredWithAppropriateProfessionalAdvice": "Las plantillas de Privana son orientativas y deben adaptarse con el asesoramiento profesional adecuado.",
    "chooseTheSuggestedControlsToCopyIntoYourDraftProgrammeYouCanReviewAndTailorThemBeforeActivation": "Elija los controles sugeridos que desea copiar en el borrador de su programa. Puede revisarlos y adaptarlos antes de activarlos.",
    "selectAll": "Seleccionar todo",
    "clearAll": "Desmarcar todo",
    "suggestedEvidence": "· Evidencia sugerida:",
    "reviewDuringTailoring": "Revisar durante la adaptación",
    "privanaTemplatesProvideAStructuredStartingPointForYourClubSAssuranceProgrammeReviewAndTailorEachProgrammeToYourOrganisationJurisdictionInsurerAndProfessionalAdviceBeforeActivation": "Las plantillas de Privana ofrecen un punto de partida estructurado para el programa de aseguramiento de su club. Antes de la activación, revise y adapte cada programa a su organización, jurisdicción, aseguradora y asesoramiento profesional.",
    "searchTemplates": "Buscar plantillas",
    "searchTemplates2": "Buscar plantillas…",
    "templateCategory": "Categoría de plantilla",
    "recommended": "Recomendado",
    "privanaTemplate": "Plantilla de Privana ·",
    "controls2": "Controles",
    "preview": "Vista previa",
    "useThisTemplate": "Usar esta plantilla",
    "backToTemplates": "Volver a las plantillas",
    "selected": "seleccionados",
    "creatingDraft": "Creando borrador…",
    "adoptDraftControls": "Adoptar controles en borrador",
    "createDraftFramework": "Crear marco en borrador",
    "frameworkRetiredSuccessfully": "Marco retirado correctamente.",
    "notConfigured": "Sin configurar",
    "createAndManageVersionedComplianceProgrammes": "Cree y gestione programas de cumplimiento versionados.",
    "newFramework": "Nuevo marco",
    "searchFrameworks": "Buscar marcos",
    "searchFrameworks2": "Buscar marcos…",
    "frameworkStatus": "Estado del marco",
    "loadingFrameworks": "Cargando marcos…",
    "chooseHowYourClubWantsToEstablishItsAssuranceProgramme": "Elija cómo desea establecer el programa de aseguramiento de su club.",
    "startFromPrivanaLibrary": "Empezar desde la biblioteca de Privana",
    "chooseACuratedAssuranceProgrammeAndTailorTheSuggestedControls": "Elija un programa de aseguramiento seleccionado y adapte los controles sugeridos.",
    "buildACustomFramework": "Crear un marco personalizado",
    "createAProgrammeFromScratchForAClubSpecificOrExternalRequirement": "Cree un programa desde cero para un requisito específico del club o externo.",
    "currentVersion": "Versión actual",
    "versions": "Versiones",
    "applicability": "Aplicabilidad",
    "notSet": "Sin establecer",
    "createFrameworkAndFirstDraftVersion": "Crear marco y primera versión en borrador",
    "privanaWillGenerateTheFrameworkReferenceAndInitialVersionAutomatically": "Privana generará automáticamente la referencia del marco y la versión inicial.",
    "name": "Nombre",
    "versionTitle": "Título de la versión",
    "effectiveFrom": "Inicio de vigencia",
    "effectiveTo": "Fin de vigencia",
    "createdFromPrivanaComplianceLibrary": "Creado desde la biblioteca de cumplimiento de Privana",
    "versionStatus": "Estado de la versión",
    "activeControls": "Controles activos",
    "awaitingReview": "Pendiente de revisión",
    "reviewAndActivateAllAttachedControlsFirst": "Revise y active primero todos los controles asociados.",
    "activateVersion": "Activar versión",
    "manageControls": "Gestionar controles",
    "editApplicability": "Editar aplicabilidad",
    "setApplicability": "Establecer aplicabilidad",
    "newVersion": "Nueva versión",
    "moreVersionActions": "Más acciones de versión",
    "supersedeVersion": "Sustituir versión",
    "markThisVersionAsHistorical": "Marcar esta versión como histórica",
    "retireVersion": "Retirar versión",
    "removeFromFutureActiveUse": "Retirar del uso activo futuro",
    "deEmphasisedDuringInitialSetup": "Menos destacado durante la configuración inicial",
    "activateFramework": "Activar marco",
    "moreFrameworkActions": "Más acciones de marco",
    "retireFramework": "Retirar marco",
    "removeFromFutureAssuranceUse": "Retirar del uso futuro de aseguramiento",
    "versionHistory": "Historial de versiones",
    "noStartDate": "Sin fecha de inicio",
    "openEnded": "Sin fecha de fin",
    "selectedVersionWorkspace": "Espacio de trabajo de la versión seleccionada",
    "reviewSuggestedControls": "Revisar controles sugeridos",
    "controlsReviewed": "Controles revisados",
    "reviewed": "revisados",
    "anAuthorizedControlsEditorMustReviewAndActivateTheseControls": "Un editor de controles autorizado debe revisar y activar estos controles.",
    "reviewControls": "Revisar controles",
    "readyToActivateVersion": "Listo para activar la versión",
    "total": "Total",
    "active": "Activo",
    "awaitingReview2": "Pendiente de revisión",
    "retired": "Retirado",
    "searchControls3": "Buscar controles",
    "searchControls4": "Buscar controles…",
    "controlStatusFilter": "Filtro de estado del control",
    "controlCategoryFilter": "Filtro de categoría del control",
    "frameworkOrder": "Orden en el marco",
    "uncategorised": "Sin categoría",
    "noReference": "Sin referencia",
    "noControlsMatchTheseFilters": "Ningún control coincide con estos filtros.",
    "createDraftFrameworkVersion": "Crear versión del marco en borrador",
    "copyControlsFromVersion": "Copiar controles de la versión",
    "doNotCopyControls": "No copiar controles",
    "searchSuggestedControls": "Buscar controles sugeridos",
    "reviewCategoryFilter": "Filtro de categoría de revisión",
    "reviewImportanceFilter": "Filtro de importancia de revisión",
    "reviewStatusFilter": "Filtro de estado de revisión",
    "selectAllDraft": "Seleccionar todos los borradores",
    "clearSelection": "Borrar selección",
    "evidence2": "· Evidencia:",
    "noRequirementSummary": "Sin resumen del requisito.",
    "openControl": "Abrir control",
    "activateSelectedControls": "Activar controles seleccionados",
    "controlsEditPermissionRequired": "Se requiere permiso de edición de controles",
    "chooseWhichActiveControlsBelongToThisDraftFrameworkVersionAndArrangeHowTheyAppearWithinTheProgramme": "Elija qué controles activos pertenecen a esta versión del marco en borrador y ordene su presentación en el programa.",
    "controlAssignmentsSaved": "Asignaciones de controles guardadas.",
    "discardUnsavedChanges": "¿Descartar los cambios sin guardar?",
    "yourStagedControlMembershipChangesWillNotBeSaved": "No se guardarán los cambios pendientes de pertenencia de los controles.",
    "keepEditing": "Seguir editando",
    "discardChanges": "Descartar cambios",
    "frameworkApplicability": "Aplicabilidad del marco",
    "doesThisProgrammeApplyToYourClub": "¿Es aplicable este programa a su club?",
    "recordWhetherThisFrameworkVersionAppliesToTheClubAndWhereUsefulTheReasonAndApplicablePeriod": "Registre si esta versión del marco es aplicable al club y, cuando proceda, el motivo y el período aplicable.",
    "applicable": "Aplicable",
    "underReview": "En revisión",
    "notApplicable": "No aplicable",
    "reasonThisDoesNotApply": "Motivo por el que no es aplicable",
    "reviewNotes": "Notas de revisión",
    "applicableFrom": "Aplicable desde",
    "applicableTo": "Aplicable hasta",
    "theseOptionalDatesDefineThePeriodForWhichThisApplicabilityDecisionApplies": "Estas fechas opcionales definen el período de aplicación de esta decisión de aplicabilidad.",
    "saveApplicability": "Guardar aplicabilidad",
    "retireFramework2": "¿Retirar el marco?",
    "retiringThisFrameworkRemovesItFromFutureActiveAssuranceUseWhilePreservingItsVersionsAssessmentsFindingsActionsEvidenceAndAuditHistory": "Retirar este marco lo excluye del uso activo futuro de aseguramiento y conserva sus versiones, evaluaciones, hallazgos, acciones, evidencias e historial de auditoría.",
    "retirementRationale": "Justificación de retirada",
    "programmeRetiredFollowingReplacementByAConsolidatedAssuranceFramework": "Programa retirado tras su sustitución por un marco de aseguramiento consolidado.",
    "supersedeFrameworkVersion": "¿Sustituir la versión del marco?",
    "retireFrameworkVersion": "¿Retirar la versión del marco?",
    "supersedingThisVersionMarksItAsHistoricalAndPreventsItFromBeingTreatedAsTheCurrentActiveVersionExistingAssessmentsFindingsActionsEvidenceAndAuditHistoryRemainUnchanged": "Sustituir esta versión la marca como histórica e impide que se considere la versión activa actual. Se conservan las evaluaciones, hallazgos, acciones, evidencias e historial de auditoría existentes.",
    "retiringThisVersionRemovesItFromFutureActiveUseWhilePreservingItsHistoricalAssessmentsEvidenceAndAuditRecord": "Retirar esta versión la excluye del uso activo futuro y conserva sus evaluaciones históricas, evidencias y registro de auditoría.",
    "supersedeRationale": "Justificación de sustitución",
    "replacedByThe2027AssuranceBaseline": "Sustituida por la base de aseguramiento de 2027.",
    "evidenceWorkspaces": "Espacios de trabajo de evidencias",
    "evidenceRegister": "Registro de evidencias",
    "insuranceIntelligence": "Análisis de seguros",
    "unableToLoadEvidence": "No se han podido cargar las evidencias.",
    "evidenceWasNotFound": "No se ha encontrado la evidencia.",
    "unableToCreateEvidence": "No se ha podido crear la evidencia.",
    "uploadAGenuinePDFPNGOrJPEGDocument": "Suba un documento PDF, PNG o JPEG auténtico.",
    "filesMustBe20MBOrSmaller": "Los archivos no deben superar los 20 MB.",
    "documentUploadFailedPleaseTryAgain": "No se ha podido subir el documento. Inténtelo de nuevo.",
    "thePrivateDocumentCouldNotBeOpened": "No se ha podido abrir el documento privado.",
    "unableToUpdateEvidence": "No se ha podido actualizar la evidencia.",
    "thatLifecycleTransitionIsNotAllowed": "Esa transición del ciclo de vida no está permitida.",
    "unableToLinkEvidence": "No se ha podido vincular la evidencia.",
    "canonicalAssuranceRecordsSupportingYourComplianceProgramme": "Registros canónicos de aseguramiento que respaldan su programa de cumplimiento.",
    "addEvidence": "Añadir evidencia",
    "activeEvidence": "Evidencias activas",
    "uploadedDocuments": "Documentos subidos",
    "manualEvidence": "Evidencias manuales",
    "unlinkedEvidence": "Evidencias sin vincular",
    "searchEvidence": "Buscar evidencias",
    "allSourceTypes": "Todos los tipos de origen",
    "manual": "Manual",
    "uploadedDocument": "Documento subido",
    "allLinkedStates": "Todos los estados de vinculación",
    "linked": "Vinculado",
    "unlinked": "Sin vincular",
    "noEvidenceYet": "Aún no hay evidencias",
    "evidenceProvidesTheRecordsDocumentsAndAssuranceMaterialThatSupportYourComplianceControlsAssessmentsFindingsAndRemediation": "Las evidencias aportan los registros, documentos y materiales de aseguramiento que respaldan sus controles, evaluaciones, hallazgos y actividades de subsanación.",
    "captured": "Recopilado",
    "links": "Vínculos",
    "createdBy": "Creado por",
    "previous": "Anterior",
    "page": "Página",
    "records": "registros",
    "next": "Siguiente",
    "recordAnAttestationOrOtherManuallyCapturedAssuranceItem": "Registre una declaración u otro elemento de aseguramiento recopilado manualmente.",
    "uploadDocument": "Subir documento",
    "securelyAttachAPrivatePDFOrImageDocument": "Adjunte de forma segura un PDF o una imagen privados.",
    "changeEvidenceType": "← Cambiar tipo de evidencia",
    "optionalSourceReference": "Referencia de origen opcional",
    "capturedAt": "Fecha de recopilación",
    "file": "Archivo",
    "pDFPNGOrJPEGMaximum20MB": "PDF, PNG o JPEG · máximo 20 MB",
    "sourceManualStatusActive": "Origen: Manual · Estado: Activo",
    "uploading": "Subiendo…",
    "createEvidence": "Crear evidencia",
    "sourceType": "Tipo de origen",
    "sourceSystem": "Sistema de origen",
    "sourceReference2": "Referencia de origen",
    "createdAt": "Fecha de creación",
    "updatedAt": "Fecha de actualización",
    "lifecycleReason": "Motivo del ciclo de vida",
    "sizeUnavailable": "Tamaño no disponible",
    "viewDownload": "Ver / Descargar",
    "noDescription": "Sin descripción.",
    "editMetadata": "Editar metadatos",
    "supersede": "Sustituir",
    "withdraw": "Retirar",
    "saveMetadata": "Guardar metadatos",
    "linkedTo": "Vinculado a",
    "unlinkEvidence": "Desvincular evidencia",
    "selectTarget": "Seleccione un destino",
    "linkEvidence": "Vincular evidencia",
    "insuranceAnalysisComplete": "Análisis de seguros completado",
    "viewInsights": "Ver conclusiones",
    "viewInsuranceIntelligence": "Ver análisis de seguros",
    "needsClubReview": "Requiere revisión del club",
    "needsReview": "Requiere revisión",
    "theInsurancePolicySetCouldNotBeLoaded": "No se ha podido cargar el conjunto de pólizas.",
    "liveProgressConnectionWasInterruptedYourAnalysisIsStillRunning": "Se ha interrumpido la conexión de progreso en directo. El análisis sigue en curso.",
    "viewComplianceImpact": "Ver impacto en cumplimiento",
    "continueReview": "Continuar revisión",
    "reviewRecommendations": "Revisar recomendaciones",
    "uploadFailed": "Error al subir",
    "uploadAtLeastOneValidPDFBeforeAnalysis": "Suba al menos un PDF válido antes del análisis.",
    "analysisCouldNotBeStarted": "No se ha podido iniciar el análisis.",
    "thisRecommendationHasAlreadyBeenReviewed": "Esta recomendación ya se ha revisado.",
    "weCouldnTSaveThisDecisionPleaseTryAgain": "No se ha podido guardar esta decisión. Inténtelo de nuevo.",
    "frameworkVersionsCouldNotBeLoaded": "No se han podido cargar las versiones de los marcos.",
    "reviewTheHighlightedControlFieldsBeforeCreatingIt": "Revise los campos del control resaltados antes de crearlo.",
    "anotherAdoptionIsAlreadyInProgressPleaseRefreshInAMoment": "Ya hay otra adopción en curso. Actualice la página en unos instantes.",
    "theSelectedFrameworkVersionIsNoLongerEditable": "La versión del marco seleccionada ya no se puede editar.",
    "thisControlAlreadyExistsInYourClub": "Este control ya existe en su club.",
    "weCouldnTAddThisLibraryControlPleaseTryAgain": "No se ha podido añadir este control de la biblioteca. Inténtelo de nuevo.",
    "weCouldnTCreateThisDraftControlPleaseTryAgain": "No se ha podido crear este borrador de control. Inténtelo de nuevo.",
    "thisControlMustBeActiveBeforeItCanBeAddedToTheFramework": "Este control debe estar activo antes de añadirlo al marco.",
    "weCouldnTCancelThisFrameworkIntentionPleaseTryAgain": "No se ha podido cancelar esta intención de asignación al marco. Inténtelo de nuevo.",
    "thisOutlookReminderAlreadyExists": "Este recordatorio de Outlook ya existe.",
    "outlookReminderCreated": "Recordatorio de Outlook creado.",
    "calendarPermissionIsNeededConnectOutlookCalendarWithoutChangingYourMailConnection": "Se requiere permiso de calendario. Conecte Outlook Calendar sin cambiar su conexión de correo.",
    "theOutlookReminderCouldNotBeCreated": "No se ha podido crear el recordatorio de Outlook.",
    "loadingInsurancePolicy": "Cargando póliza de seguro…",
    "insuranceIntelligence2": "← Análisis de seguros",
    "insuranceIntelligence3": "Análisis de seguros ·",
    "reviewComplete": "Revisión completada",
    "reviewInProgress": "Revisión en curso",
    "analysisComplete": "Análisis completado",
    "preparingAnalysis": "Preparando análisis",
    "reanalyse": "Volver a analizar",
    "insurer": "Aseguradora",
    "policyNumber": "Número de póliza",
    "policyPeriod": "Período de la póliza",
    "primaryLimit": "Límite principal",
    "excess": "Franquicia",
    "underwriter": "Suscriptor",
    "analysing": "Analizando",
    "of": "de",
    "pagesProcessed": "páginas procesadas",
    "yourPreviousCompletedAnalysisRemainsAvailableWhileThisAnalysisRuns": "El análisis completado anterior sigue disponible mientras se ejecuta este análisis.",
    "analysisCouldNotBeCompleted": "No se ha podido completar el análisis",
    "yourDocumentsAndAnyPreviousCompletedAnalysisAreSafePleaseTryAgain": "Sus documentos y los análisis completados anteriores están a salvo. Inténtelo de nuevo.",
    "retryAnalysis": "Reintentar análisis",
    "importantForYourAttention": "Aspectos que requieren su atención",
    "whyThisMatters": "Por qué es relevante",
    "page2": "· página",
    "viewSource": "· Ver fuente",
    "policyReview": "Revisión de la póliza",
    "privanaFoundRecommendationsFromThisPolicyReviewThemBeforeAnythingChangesInCompliance": "Privana ha identificado recomendaciones a partir de esta póliza. Revíselas antes de que se realice cualquier cambio en cumplimiento.",
    "reviewed2": "revisados ·",
    "remaining": "pendientes",
    "existingMatches": "coincidencias existentes ·",
    "suggestedControls": "controles sugeridos ·",
    "dates": "fechas ·",
    "needsReview2": "requieren revisión",
    "existingControlsMatched": "controles existentes coincidentes",
    "privanaFoundControlsThatMayAlreadyAddressPolicyRequirements": "Privana ha identificado controles que podrían cubrir ya los requisitos de la póliza.",
    "suggestedControls2": "controles sugeridos",
    "requirementsThatMayNeedAnAdditionalControlOrClubReview": "Requisitos que podrían necesitar un control adicional o la revisión del club.",
    "importantDates": "fechas importantes",
    "policyDatesAndPreparationMilestonesIdentified": "Fechas de la póliza e hitos de preparación identificados.",
    "review": "Revisar",
    "matches": "Coincidencias",
    "suggestedControls3": "Controles sugeridos",
    "dates2": "Fechas",
    "reviewFilter": "Filtro de revisión",
    "whatThePolicyRequires": "Lo que exige la póliza",
    "policyRequirement": "Requisito de la póliza",
    "privanaSRecommendedMatch": "Coincidencia recomendada por Privana",
    "privanaSSuggestedControl": "Control sugerido por Privana",
    "draftARepeatablePolicyComplianceControl": "Redactar un control repetible de cumplimiento de la póliza",
    "status2": "Estado:",
    "frameworks2": "Marcos:",
    "none": "Ninguno",
    "latestAssessment": "Última evaluación:",
    "notAssessed2": "sin evaluar",
    "evidence3": "Evidencia:",
    "supported": "Respaldado",
    "noCurrentSupport": "Sin respaldo vigente",
    "strongMatch": "Coincidencia sólida",
    "possibleMatch": "Posible coincidencia",
    "whyPrivanaRecommendsIt": "Por qué lo recomienda Privana",
    "libraryProvenance": "Procedencia de la biblioteca:",
    "version3": "· versión",
    "addedToFramework": "Añadido al marco",
    "readyToAddToFramework": "Listo para añadir al marco",
    "waitingForControlActivation": "Pendiente de activación del control",
    "matchConfirmed": "Coincidencia confirmada",
    "notAMatch": "No coincide",
    "dismissed": "Descartado",
    "libraryControlAdded": "Control de la biblioteca añadido",
    "draftControlCreated": "Borrador de control creado",
    "recommendationReviewed": "Recomendación revisada",
    "target": "Destino:",
    "viewControl": "Ver control",
    "adding": "Añadiendo…",
    "cancelling": "Cancelando…",
    "cancelFrameworkIntention": "Cancelar intención de asignación al marco",
    "viewFramework": "Ver marco",
    "saving": "Guardando…",
    "confirmMatch": "Confirmar coincidencia",
    "markForReview": "Marcar para revisión",
    "addToMyControls": "Añadir a mis controles",
    "createDraftControl": "Crear borrador de control",
    "frameworkEditAccessIsRequired": "Se requiere acceso de edición de marcos",
    "addToFramework": "Añadir al marco",
    "createAddToFramework": "Crear y añadir al marco",
    "controlsEditAccessIsRequiredToAdoptThisRecommendation": "Se requiere acceso de edición de controles para adoptar esta recomendación.",
    "dismiss": "Descartar",
    "youReAllCaughtUpInThisSection": "No tiene revisiones pendientes en esta sección.",
    "viewCompleted": "Ver completados",
    "privanaDerivedMilestone": "Hito derivado por Privana",
    "policyDeadline": "Plazo de la póliza",
    "policyPeriodDate": "Fecha del período de la póliza",
    "suggestedMilestoneDerivedFromPolicyInformationNotAContractualCondition": "Hito sugerido a partir de la información de la póliza; no es una condición contractual.",
    "viewInComplianceCalendar": "Ver en el calendario de cumplimiento",
    "addToOutlook": "Añadir a Outlook",
    "viewSource2": "Ver fuente",
    "policyRequirements": "Requisitos de la póliza",
    "extractedClausesRemainAvailableGroupedForEasierReview": "cláusulas extraídas siguen disponibles, agrupadas para facilitar su revisión.",
    "expandAll": "Expandir todo",
    "collapseAll": "Contraer todo",
    "confidencePage": "% de confianza · página",
    "privanaSInterpretation": "Interpretación de Privana",
    "sourceDocuments": "Documentos de origen",
    "originalDocumentsUsedForThisAnalysis": "Documentos originales utilizados para este análisis.",
    "addPDFs": "Añadir PDF",
    "pages": "páginas ·",
    "view": "Ver",
    "removeDocument": "Quitar documento",
    "analysePolicy": "Analizar póliza",
    "privanaLibraryControl": "Control de la biblioteca de Privana",
    "suggestedControl": "Control sugerido",
    "reviewThisReadOnlyLibraryControlBeforeAddingItToYourProgramme": "Revise este control de la biblioteca de solo lectura antes de añadirlo a su programa.",
    "reviewPrivanaSRecommendationBeforeAddingItToYourComplianceProgramme": "Revise la recomendación de Privana antes de añadirla a su programa de cumplimiento.",
    "destination": "Destino",
    "chooseTheFrameworkDestinationPrivanaWillRememberItWhileYouReviewAndActivateTheDraftControl": "Elija el marco de destino. Privana lo recordará mientras revisa y activa el borrador de control.",
    "targetFrameworkVersion": "Versión del marco de destino",
    "chooseAFrameworkVersion": "Elija una versión del marco",
    "evaluation2": "Evaluación:",
    "source": "Origen",
    "privanaLibrary": "Biblioteca de Privana ·",
    "libraryControlTemporarilyUnavailable": "Control de la biblioteca no disponible temporalmente",
    "privanaCannotSafelyLoadThisHistoricalLibraryControlRightNowNoGeneratedControlWillBeSubstituted": "Privana no puede cargar de forma segura este control histórico de la biblioteca en este momento. No se sustituirá por un control generado.",
    "creating": "Creando…",
    "createDraftControlContinue": "Crear borrador de control y continuar",
    "analysisHistory": "Historial de análisis",
    "pages2": "páginas",
    "privanaProvidesPolicyInterpretationAndAssuranceSupportNotLegalCertificationReviewMaterialInsuranceMattersWithYourBrokerInsurerOrProfessionalAdviser": "Privana ofrece apoyo para la interpretación de pólizas y el aseguramiento, no una certificación jurídica. Revise las cuestiones relevantes del seguro con su corredor, aseguradora o asesor profesional.",
    "insuranceIntelligenceCouldNotBeLoaded": "No se ha podido cargar el análisis de seguros.",
    "thePolicySetCouldNotBeCreated": "No se ha podido crear el conjunto de pólizas.",
    "turnComplexInsuranceWordingIntoClearObligationsAssuranceGapsAndActionsForYourClub": "Convierta el texto complejo de los seguros en obligaciones claras, carencias de aseguramiento y acciones para su club.",
    "uploadInsurancePolicy": "Subir póliza de seguro",
    "privanaUsesAIToIdentifyAndOrganizePotentiallyImportantPolicyWordingReviewMaterialCoverageAndContractualQuestionsWithYourBrokerInsurerOrProfessionalAdviserWhereAppropriate": "Privana utiliza IA para identificar y organizar textos de pólizas potencialmente importantes. Revise las cuestiones relevantes de cobertura y contrato con su corredor, aseguradora o asesor profesional cuando proceda.",
    "policyTitle": "Título de la póliza",
    "insuranceType": "Tipo de seguro",
    "insurerOptional": "Aseguradora (opcional)",
    "policyNumberOptional": "Número de póliza (opcional)",
    "createThePolicySetFirstThenSecurelyAddUpTo10PrivatePDFs100MBAnd1500PagesEachClassifyEachScheduleWordingOrEndorsementAndStartDurableAnalysis": "Cree primero el conjunto de pólizas y añada de forma segura hasta 10 PDF privados (100 MB y 1500 páginas cada uno). Clasifique cada documento de condiciones particulares, condicionado o suplemento e inicie el análisis persistente.",
    "createPolicySet": "Crear conjunto de pólizas",
    "completedSafetyChecklists": "Listas de comprobación de seguridad operativa completadas",
    "riskAssessments": "Evaluaciones de riesgos",
    "alertEvents": "Eventos de alerta",
    "theSourceProvidesSupportingAssuranceForTheControl": "La fuente aporta respaldo de aseguramiento al control.",
    "theSourceMayDemonstrateThatTheControlIsNotBeingSatisfied": "La fuente puede demostrar que el control no se cumple.",
    "theSourceDemonstratesCorrectiveRemediationActivity": "La fuente demuestra actividad correctiva o de subsanación.",
    "theSourceIndependentlyVerifiesTheControlCondition": "La fuente verifica de forma independiente la condición del control.",
    "thisNativeEvidenceSourceIsNotSupported": "Esta fuente nativa de evidencias no es compatible.",
    "thatSourceCapabilityIsNotAvailable": "Esa capacidad de origen no está disponible.",
    "selectAValidActiveControl": "Seleccione un control activo válido.",
    "theRequestedMappingOrControlIsNoLongerAvailable": "La correspondencia o el control solicitados ya no están disponibles.",
    "mappingsCanOnlyTargetActiveControls": "Las correspondencias solo pueden apuntar a controles activos.",
    "selectAValidEvidenceRelationship": "Seleccione una relación de evidencia válida.",
    "recordsConsideredPerSyncMustBeAWholeNumberFrom1To250": "Los registros considerados por sincronización deben ser un número entero entre 1 y 250.",
    "theSourceConfigurationIsTooLarge": "La configuración de origen es demasiado grande.",
    "thisSourceIsAlreadyMappedToThatControl": "Esta fuente ya está vinculada a ese control.",
    "providerSourceCapabilityAndControlCannotBeChanged": "No se pueden cambiar el proveedor, la capacidad de origen ni el control.",
    "youDoNotHavePermissionToChangeIntegrations": "No tiene permiso para modificar las integraciones.",
    "theIntegrationsOperationCouldNotBeCompleted": "No se ha podido completar la operación de integraciones.",
    "never": "Nunca",
    "editMapping": "Editar correspondencia",
    "addMapping": "Añadir correspondencia",
    "sourceCapability": "Capacidad de origen",
    "activeControl": "Control activo",
    "searchKeyOrTitle": "Buscar clave o título…",
    "selectAnActiveControl": "Seleccione un control activo",
    "relationship": "Relación",
    "recordsConsideredPerSync": "Registros considerados por sincronización",
    "limitsHowManyRecentSourceRecordsPrivanaReviewsDuringEachSync": "Limita cuántos registros recientes de origen revisa Privana en cada sincronización.",
    "enabled": "Habilitado",
    "saveMapping": "Guardar correspondencia",
    "mappings": "correspondencias",
    "mapNativeSourceCapabilitiesToActiveControlsDisablingAMappingOnlyAffectsFutureSyncsHistoricalEvidenceRemainsUnchanged": "Vincule capacidades nativas de origen a controles activos. Deshabilitar una correspondencia solo afecta a las sincronizaciones futuras; las evidencias históricas se conservan.",
    "noSupportedSourceCapabilitiesAreCurrentlyAvailableForThisClub": "No hay capacidades de origen compatibles disponibles actualmente para este club.",
    "addMapping2": "Añadir correspondencia",
    "noMappingsConfigured": "No hay correspondencias configuradas.",
    "configuration": "Configuración",
    "disabled": "Deshabilitado",
    "latest": "Últimos",
    "disable": "Deshabilitar",
    "enable": "Habilitar",
    "syncCouldNotBeCompletedPleaseTryAgain": "No se ha podido completar la sincronización. Inténtelo de nuevo.",
    "loadingNativeIntegrations": "Cargando integraciones nativas…",
    "nativeEvidenceIntegrations": "Integraciones nativas de evidencias",
    "configureAndOperateTrustedPrivanaSourcesThatProduceComplianceEvidence": "Configure y gestione fuentes de confianza de Privana que generan evidencias de cumplimiento.",
    "addIntegration": "Añadir integración",
    "addAnIntegration": "Añadir una integración",
    "discoverTrustedEvidenceSourcesForYourAssuranceProgramme": "Descubra fuentes de evidencias de confianza para su programa de aseguramiento.",
    "useCompletedSafetyChecksAndRiskAssessmentsAsTrustedComplianceEvidence": "Utilice comprobaciones de seguridad operativa y evaluaciones de riesgos completadas como evidencias de cumplimiento de confianza.",
    "native": "Nativa",
    "comingSoon": "Próximamente",
    "bringIdentityMFAPrivilegedAccessAndSecurityAssuranceSignalsIntoPrivanaCompliance": "Incorpore señales de aseguramiento sobre identidad, MFA, acceso privilegiado y seguridad a Privana Compliance.",
    "moreComingSoon": "¡Próximamente más!",
    "privanaIsContinuallyExpandingTheSystemsThatCanContributeTrustedComplianceEvidence": "Privana amplía continuamente los sistemas que pueden aportar evidencias de cumplimiento de confianza.",
    "nATIVE": "NATIVA",
    "configured": "Configurado",
    "readyToConfigure": "Listo para configurar",
    "available2": "Disponible",
    "unavailable": "No disponible",
    "enabledMappings": "Correspondencias habilitadas",
    "evidenceProduced": "Evidencias generadas",
    "lastOutcome": "Último resultado",
    "completedWithErrors": "Completado con errores",
    "successful": "Correcto",
    "notSynced": "Sin sincronizar",
    "sourceCapabilities": "Capacidades de origen",
    "lastSync": "Última sincronización",
    "viewEvidence": "Ver evidencias",
    "syncing": "Sincronizando…",
    "syncNow": "Sincronizar ahora",
    "syncComplete": "Sincronización completada",
    "integrationUnavailable": "Integración no disponible",
    "thisProviderIsNotCurrentlyAvailableForYourClubRefreshThePageOrContactAnAdministrator": "Este proveedor no está disponible actualmente para su club. Actualice la página o contacte con un administrador.",
    "search": "Buscar…",
    "remediationActions": "acciones de subsanación",
    "actionsTrackTheWorkRequiredToRemediateComplianceFindings": "Las acciones permiten hacer seguimiento del trabajo necesario para subsanar los hallazgos de cumplimiento.",
    "findingsTrackComplianceGapsIdentifiedThroughAssessmentsAndAssuranceReviews": "Los hallazgos registran las carencias de cumplimiento identificadas mediante evaluaciones y revisiones de aseguramiento.",
    "raiseFindingsFromEligibleAssessmentResults": "Registre hallazgos a partir de resultados de evaluación que lo permitan.",
    "completionSummary": "Resumen de finalización",
    "blockedReason": "Motivo del bloqueo",
    "cancellationRationale": "Justificación de cancelación",
    "action": "Acción",
    "due": "Vencimiento",
    "overdue2": " · Vencido",
    "start": "Iniciar",
    "block": "Bloquear",
    "complete2": "Completar",
    "resume": "Reanudar",
    "unableToLoadFindings": "No se han podido cargar los hallazgos.",
    "closureSummary": "Resumen de cierre",
    "complianceFindings": "Hallazgos de cumplimiento",
    "formalDeficienciesAndExceptionsRaisedFromCanonicalAssessmentResults": "Deficiencias y excepciones formales registradas a partir de resultados canónicos de evaluación.",
    "openFindings2": "Hallazgos abiertos",
    "readyForReview": "Listo para revisión",
    "overdueActions": "Acciones vencidas",
    "findingStatus": "Estado del hallazgo",
    "findingSeverity": "Gravedad del hallazgo",
    "allSeverities": "Todos los niveles de gravedad",
    "overdue3": "vencidos",
    "assessmentResult": "Resultado de la evaluación",
    "closed": "Cerrado",
    "remediationActions2": "Acciones de subsanación",
    "actionTitle": "Título de la acción",
    "selectActionOwner": "Seleccione un responsable de la acción",
    "addAction": "Añadir acción",
    "noRemediationActionsYet": "Aún no hay acciones de subsanación.",
    "theDailyWorkQueueForResolvingComplianceFindings": "La cola de trabajo diario para resolver los hallazgos de cumplimiento.",
    "actionStatus": "Estado de la acción",
    "allPriorities": "Todas las prioridades",
    "dueState": "Estado del vencimiento",
    "allDueDates": "Todos los vencimientos",
    "dueSoon": "Próximo vencimiento",
    "noDueDate": "Sin fecha de vencimiento",
    "unknownFailure": "No se ha podido completar la operación de cumplimiento.",
    "noControls": "Aún no hay controles",
    "noFrameworks": "Aún no hay marcos",
    "noActions": "Aún no hay acciones de subsanación",
    "noFindings": "Aún no hay hallazgos",
    "evaluatedCount": "{evaluated} / {total} evaluados",
    "completionPercent": "{percent} completado",
    "assessmentIncomplete": "Esta evaluación aún no se puede completar. Quedan {count} controles sin evaluar{references}.",
    "allStatus": "Todos los estados",
    "allFrameworks": "Todos los marcos",
    "allAssessmentTypes": "Todos los tipos de evaluación",
    "allResults": "Todos los resultados",
    "stepNumber": "Paso {step}",
    "assessedScope": "{assessed} de {total} versiones vigentes del marco evaluadas · {controls} controles aplicables",
    "findingSeverityCounts": "{critical} críticos · {high} altos",
    "dueCounts": "Vencen en 30 días · {overdue} vencidas",
    "timesIn": "Horas mostradas en {timezone}",
    "selectDate": "Seleccionar {date}",
    "ownerName": "Responsable: {owner}",
    "priorityLevel": "Prioridad {priority}",
    "moreCount": "+{count} más",
    "openTarget": "Abrir {target}",
    "dateTime": "Fecha y hora",
    "orderNumber": "Orden {order}",
    "referenceFor": "Referencia del marco para {control}",
    "reorderControl": "Reordenar o quitar {control}",
    "previewName": "Vista previa · {name}",
    "versionSuccess": "Versión {status} correctamente.",
    "versionNumber": "Versión {version}",
    "suggestedReviewCounts": "{total} controles sugeridos · {approved} aprobados · {awaiting} pendientes de revisión",
    "readyActiveCounts": "{active} / {total} activos · Listo para activar la versión",
    "reviewedControls": "{reviewed} de {total} controles revisados",
    "selectControl": "Seleccionar {control}",
    "activatedControls": "{count} controles activados.",
    "evidenceTransition": "¿Por qué se está marcando esta evidencia como {status}?",
    "analysingPolicy": "Analizando {title} · {percent}",
    "documentsCountOne": "{count} documento",
    "documentsCountOther": "{count} documentos",
    "reviewCount": "Por revisar {count}",
    "completedCount": "Completados {count}",
    "addToFrameworkName": "Añadir a {name}",
    "importanceLevel": "Importancia {importance}",
    "providerUnavailable": "La capacidad de {provider} no está disponible para este club.",
    "providerMappings": "Correspondencias de {provider}",
    "elementDescription": "Utilice eventos de alerta supervisados y excepciones del entorno físico como evidencias de cumplimiento de confianza.",
    "mappingView": "Ver correspondencias",
    "mappingManage": "Gestionar correspondencias",
    "configure": "Configurar",
    "syncNeedsMapping": "Añada al menos una correspondencia habilitada antes de sincronizar.",
    "syncNeedsAvailable": "Habilite una correspondencia para una capacidad de origen disponible antes de sincronizar.",
    "overdueCount": "{count} vencidas",
    "insuranceQueued": "En cola",
    "insurancePreparingdocuments": "Preparando documentos",
    "insuranceReadingpolicy": "Leyendo póliza",
    "insuranceIdentifyingrequirements": "Identificando requisitos",
    "insuranceCheckingyourCompliancecontrols": "Comprobando sus controles de cumplimiento",
    "insurancePreparingrecommendations": "Preparando recomendaciones",
    "insuranceFinalisinganalysis": "Finalizando análisis",
    "insuranceAnalysisfailed": "Error de análisis",
    "insuranceExclusions": "Exclusiones",
    "insuranceConditionsofcover": "Condiciones de cobertura",
    "insuranceRecommendations": "Recomendaciones",
    "insuranceDefinitionspolicyinformation": "Definiciones e información de la póliza",
    "insuranceClaimsnotification": "Siniestros y notificación",
    "insuranceDataprotectionprivacy": "Protección de datos y privacidad",
    "insuranceIncidentresponse": "Respuesta a incidentes",
    "insuranceOperationalresilience": "Resiliencia operativa",
    "insuranceSecurityrequirements": "Requisitos de seguridad",
    "insuranceGovernancepeople": "Gobernanza y personal",
    "insuranceOtherpolicywording": "Otros textos de la póliza",
    "evidenceMethodSummary": " · Evidencia: {method}",
    "diagnostic": "{message} (Código: {code}; Solicitud: {request})",
    "nativeChecklist": "Lista de comprobación de seguridad operativa: {title}",
    "nativeRisk": "Evaluación de riesgos: {title}",
    "nativeElement": "Alerta de Element: {title}",
    "nativeResult": "Completada con resultado {result}.",
    "nativeRiskDescription": "Puntuación de riesgo {score}; estado {status}.",
    "controlCount": "{count} controles",
    "continue": "Continuar",
    "messageControls": "{value1} ({value2}) · {value3} · {value4} controles",
    "messageCompleted2": "{value1} · {value2} · Completada {value3}",
    "messageCreated": "Creado {value1}",
    "messageEvaluated": "{value1} / {value2}  evaluados",
    "messageControlVersion": "{value1} · {value2} · Versión del control {value3}",
    "messageFinding": "Hallazgo {value1} · {value2}",
    "messageTimesShownIn": "Horas mostradas en {value1}",
    "messageManifestV": "Manifiesto v{value1} · SHA-256 {value2}",
    "messageTimesShownIn2": "Horas mostradas en {value1}",
    "messageMore": "+{value1} más",
    "messageAvailable": "{value1} disponibles",
    "messageVersion2": "{value1} · {value2} · Versión {value3}",
    "messageAssigned": "{value1} asignados",
    "messageVersion22": "{value1} · {value2} · Versión {value3}",
    "messageFrameworkReferenceFor": "Referencia del marco para {value1}",
    "messageControlsAssigned": "{value1} Controles asignados",
    "messageSuggestedEvidence": "{value1} · Evidencia sugerida: {value2}",
    "messagePrivanaTemplate": "Plantilla de Privana · {value1} Controles",
    "messageSelected": "{value1} seleccionados",
    "messageVersion": "Versión {value1}",
    "messageControls2": "{value1} Controles",
    "messageReviewed": "{value1} / {value2} revisados",
    "messageVersion23": "{value1} · {value2} · Versión {value3}",
    "messageSelected2": "{value1} seleccionados",
    "messageEvidence2": "{value1} · {value2} · Evidencia: {value3}",
    "messageSelected3": "{value1} seleccionados",
    "messageVersion3": "Versión {value1}",
    "messagePage": "Página {value1} · {value2} registros",
    "messageInsuranceIntelligence3": "Análisis de seguros · {value1}",
    "messageAnalysing": "Analizando {value1}",
    "messageOf": "{value1} · {value2} de {value3} páginas procesadas",
    "messagePage2": "{value1} · página {value2} · Ver fuente",
    "messageOf2": "{value1} de {value2} revisados · {value3} pendientes",
    "messageExistingMatches": "{value1} coincidencias existentes · {value2} controles sugeridos · {value3} fechas · {value4} requieren revisión",
    "messageReview": "Revisar {value1} →",
    "messageStatus2": "Estado: {value1}",
    "messageFrameworks2": "Marcos: {value1}",
    "messageLatestAssessment": "Última evaluación: {value1}",
    "messageEvidence3": "Evidencia: {value1}",
    "messageLibraryProvenance": "Procedencia de la biblioteca: {value1} · versión {value2} · {value3}",
    "messageTarget": "Destino: {value1} · Versión {value2}",
    "messagePage3": "Página {value1} · Ver fuente",
    "messageAll": "Las cláusulas extraídas ({value1}) siguen disponibles, agrupadas para facilitar su revisión.",
    "messageConfidencePage": "{value1}% de confianza · página {value2}",
    "messagePage22": "{value1} · página {value2} · Ver fuente",
    "messagePages": "{value1} · {value2} · {value3} páginas · {value4}",
    "messageVersion24": "{value1} · Versión {value2} · {value3} · {value4} Controles",
    "messageEvaluation2": "Evaluación: {value1} · Evidencia: {value2}",
    "messagePrivanaLibrary": "Biblioteca de Privana · {value1} · Versión {value2} · {value3}",
    "messagePage23": "{value1} · página {value2} · Ver fuente",
    "messagePages2": "{value1} páginas",
    "messageMappings": "{value1} correspondencias",
    "messageLatest": "Últimos {value1}",
    "messageOverdue3": "{value1} vencidos",
    "criticalHigh": "Crítico / Alto",
    "frameworkControl": "Marco / Control",
    "outlookRenewal": "Preparar la renovación de {title}",
    "outlookPolicy": "Póliza: {title}",
    "outlookInsurer": "Aseguradora: {name}",
    "outlookNumber": "Número de póliza: {number}",
    "outlookExpiry": "Vencimiento: {date}",
    "futureRelease": "Este espacio de trabajo está preparado para una futura versión de cumplimiento."
  },
  "enums": {
    "low": "Bajo",
    "medium": "Medio",
    "high": "Alto",
    "critical": "Crítico",
    "open": "Abierto",
    "active": "Activo",
    "draft": "Borrador",
    "retired": "Retirado",
    "superseded": "Sustituidos",
    "withdrawn": "Retirado",
    "applicable": "Aplicable",
    "not_applicable": "No aplicable",
    "under_review": "En revisión",
    "in_progress": "En curso",
    "completed": "Completado",
    "cancelled": "Cancelado",
    "accepted": "Aceptado",
    "remediation_in_progress": "Subsanación en curso",
    "ready_for_review": "Listo para revisión",
    "closed": "Cerrado",
    "void": "Anulado",
    "blocked": "Bloqueado",
    "compliant": "Cumple",
    "partially_compliant": "Cumple parcialmente",
    "non_compliant": "No cumple",
    "not_evaluated": "Sin evaluar",
    "initial": "Inicial",
    "periodic": "Periódica",
    "reassessment": "Reevaluación",
    "manual": "Manual",
    "automated": "Automatizado",
    "integrated": "Integrado",
    "hybrid": "Híbrido",
    "manual_attestation": "Declaración manual",
    "document": "Documento",
    "system_evidence": "Evidencia del sistema",
    "integrated_evidence": "Evidencia integrada",
    "sensor_telemetry": "Telemetría de sensores",
    "uploaded_document": "Documento subido",
    "privana_safety": "Privana Safety",
    "privana_element": "Privana Element",
    "completed_checklist": "Lista de comprobación completada",
    "risk_assessment": "Evaluación de riesgos",
    "alert_event": "Evento de alerta",
    "supports": "Respalda",
    "contradicts": "Contradice",
    "remediates": "Subsana",
    "verifies": "Verifica",
    "control": "Control",
    "assessment": "Evaluación",
    "finding": "Hallazgo",
    "action": "Acción",
    "framework": "Marco",
    "framework_version": "Versión del marco",
    "evidence": "Evidencia",
    "evidence_link": "Vínculo de evidencia",
    "audit_pack": "Paquete de auditoría",
    "generating": "Generando",
    "generated": "Generado",
    "queued": "En cola",
    "processing": "Procesando",
    "failed": "Error",
    "error": "Error",
    "uploaded": "Subido",
    "uploading": "Subiendo",
    "policy_wording": "Condicionado de póliza",
    "policy_schedule": "Condiciones particulares",
    "endorsement": "Suplemento",
    "renewal_terms": "Condiciones de renovación",
    "supporting_document": "Documento justificativo",
    "other": "Otro",
    "to_review": "Pendiente de revisión",
    "reviewed": "Revisado",
    "adopted": "Adoptado",
    "dismissed": "Descartado",
    "exclusion": "Exclusión",
    "condition": "Condición de cobertura",
    "recommendation": "Recomendación",
    "definition": "Definición",
    "informational": "Informativo",
    "coverage": "Cobertura",
    "notification_obligation": "Obligación de notificación",
    "warranty": "Garantía",
    "obligation": "Obligación",
    "assessmentCoverage": "Cobertura de evaluación",
    "findingResolution": "Resolución de hallazgos",
    "actionTimeliness": "Cumplimiento de plazos de acciones",
    "evidenceCoverage": "Cobertura de evidencias",
    "scanned": "Examinados",
    "created": "Creados",
    "unchanged": "Sin cambios",
    "linked": "Vinculados",
    "skipped": "Omitidos",
    "sourceErrors": "Errores de origen",
    "linkErrors": "Errores de vinculación",
    "current": "Vigente",
    "historical": "Histórico",
    "pass": "Superado",
    "fail": "No superado",
    "review_due": "Revisión pendiente",
    "privana_object_storage": "Almacenamiento de objetos de Privana",
    "actions": "Acciones",
    "frameworks": "Marcos",
    "assessments": "Evaluaciones",
    "control_created": "Control creado",
    "control_updated": "Control actualizado",
    "control_status_changed": "Estado de control cambiado",
    "control_version_created": "Versión de control creada",
    "framework_created": "Marco creado",
    "framework_version_created": "Versión de marco creada",
    "framework_control_linked": "Control vinculado al marco",
    "framework_control_unlinked": "Control desvinculado del marco",
    "framework_controls_reconciled": "Controles del marco conciliados",
    "framework_control_copied": "Control del marco copiado",
    "framework_created_from_library": "Marco creado desde la biblioteca",
    "control_created_from_library": "Control creado desde la biblioteca",
    "framework_status_changed": "Estado del marco cambiado",
    "framework_version_status_changed": "Estado de versión del marco cambiado",
    "framework_applicability_changed": "Aplicabilidad del marco cambiada",
    "assessment_created": "Evaluación creada",
    "assessment_status_changed": "Estado de evaluación cambiado",
    "assessment_results_initialized": "Resultados de evaluación inicializados",
    "assessment_result_recorded": "Resultado de evaluación registrado",
    "finding_created": "Hallazgo creado",
    "finding_metadata_changed": "Metadatos de hallazgo cambiados",
    "finding_status_changed": "Estado de hallazgo cambiado",
    "action_created": "Acción creada",
    "action_metadata_changed": "Metadatos de acción cambiados",
    "action_status_changed": "Estado de acción cambiado",
    "evidence_created": "Evidencia creada",
    "evidence_document_uploaded": "Documento de evidencia subido",
    "evidence_metadata_changed": "Metadatos de evidencia cambiados",
    "evidence_status_changed": "Estado de evidencia cambiado",
    "evidence_linked": "Evidencia vinculada",
    "evidence_unlinked": "Evidencia desvinculada",
    "evidence_source_mapping_created": "Correspondencia de origen de evidencia creada",
    "evidence_source_mapping_changed": "Correspondencia de origen de evidencia cambiada",
    "evidence_source_mapping_disabled": "Correspondencia de origen de evidencia deshabilitada",
    "trusted_evidence_created": "Evidencia de confianza creada",
    "integrated_evidence_superseded": "Evidencia integrada sustituida",
    "audit_pack_created": "Paquete de auditoría creado",
    "audit_pack_generated": "Paquete de auditoría generado",
    "audit_pack_voided": "Paquete de auditoría anulado",
    "controls": "Controles",
    "findings": "Hallazgos",
    "evidence_records": "Registros de evidencia",
    "current_evidence": "Evidencias vigentes",
    "current_documents_included": "Documentos vigentes incluidos",
    "suggested": "Sugerido",
    "confirmed": "Confirmado",
    "insurance": "Seguros",
    "insurance_policy": "Póliza de seguro",
    "insurance_document": "Documento de seguro",
    "insurance_date": "Fecha de seguro",
    "insurance_analysis": "Análisis de seguros",
    "insurance_document_uploaded": "Documento de seguro subido",
    "insurance_analysis_started": "Análisis de seguros iniciado",
    "insurance_calendar_event_added": "Evento de calendario de seguro añadido",
    "preparing": "Preparando",
    "validating": "Validando",
    "evidence_source_mapping": "Correspondencia de origen de evidencia",
    "verified": "Verificado",
    "partial": "Parcial",
    "not_started": "Sin iniciar"
  },
  "controlValues": {
    "importance": {
      "low": "Bajo",
      "medium": "Medio",
      "high": "Alto",
      "critical": "Crítico"
    },
    "evaluationMethod": {
      "manual": "Revisión manual",
      "automated": "Revisión automatizada",
      "integrated": "Revisión integrada",
      "hybrid": "Revisión híbrida"
    },
    "evidenceMethod": {
      "manual_attestation": "Declaración manual",
      "document": "Revisión documental",
      "system_evidence": "Evidencia del sistema",
      "integrated_evidence": "Evidencia integrada",
      "sensor_telemetry": "Telemetría de sensores",
      "hybrid": "Evidencia híbrida"
    }
  },
  "assurance": {
    "Not Assessed": "Sin evaluar",
    "At Risk": "En riesgo",
    "Attention Needed": "Requiere atención",
    "Strong": "Sólido"
  },
  "report": {
    "title": "Paquete de auditoría",
    "brand": "PRIVANA COMPLIANCE",
    "generated": "Generado {date}\nZona horaria del club: {timezone}\nIntegridad SHA-256: {hash}",
    "executive": "Resumen ejecutivo",
    "summary": "{assessment} respecto a {framework} {version}. Controles: {controls}; hallazgos: {findings}; acciones: {actions}; registros de evidencia: {evidence}.",
    "frameworkAssessment": "Marco y evaluación",
    "scope": "Marco: {key} — {framework}\nVersión: {version} ({status})\nVigencia: {from} a {to}\nEvaluación: {assessment} ({type})\nIniciada: {started}\nCompletada: {completed}",
    "openEnded": "sin fecha de fin",
    "controlResults": "Resultados de controles",
    "noNarrative": "Sin explicación",
    "evaluated": " · Evaluado {date}",
    "findings": "Hallazgos",
    "closed": " · Cerrado {date}",
    "noFindings": "No hay hallazgos registrados.",
    "actions": "Acciones de subsanación",
    "due": "Vencimiento {date}",
    "completed": " · Completada {date}",
    "noActions": "No hay acciones de subsanación registradas.",
    "evidence": "Registro de evidencias",
    "noEvidence": "No hay evidencias registradas.",
    "audit": "Registro de auditoría",
    "integrity": "Información de generación e integridad",
    "integrityText": "Formato del manifiesto: {version}\nConvención de hash: SHA-256 del contenido JSON canónico excluyendo el miembro integrity.\nHash del manifiesto: {hash}\nEsta es una instantánea histórica inmutable, no una certificación regulatoria.",
    "page": "Privana · {key} · Página {page} de {total}"
  },
  "warnings": {
    "non_compliant": "La evaluación tiene resultados de incumplimiento",
    "open_findings": "Quedan hallazgos abiertos",
    "findings_review": "Hay hallazgos listos para revisión",
    "withdrawn_evidence": "Hay evidencias retiradas vinculadas al alcance",
    "missing_evidence": "Hay controles pertinentes sin evidencias positivas activas"
  }
};
